import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Plus, Settings, MessageSquare, CreditCard } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <Card className="p-4 mb-8">
      <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate("/host/properties/add")}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add Property
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate("/host/messages")}
        >
          <MessageSquare className="mr-2 h-4 w-4" />
          Messages
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate("/host/settings/payment-methods/add")}
        >
          <CreditCard className="mr-2 h-4 w-4" />
          Add Payment Method
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate("/host/settings")}
        >
          <Settings className="mr-2 h-4 w-4" />
          Settings
        </Button>
      </div>
    </Card>
  );
};